import type { Mode } from 'core/domain/Mode'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentChargesRepository } from '../infra/ShipmentChargesRepository'

export type GetShipmentChargesFactoryDependencies = {
  repository: ShipmentChargesRepository
}

export function getShipmentChargeTypesFactory({
  repository,
}: GetShipmentChargesFactoryDependencies) {
  return function getShipmentChargeTypes(mode?: Mode, config?: { signal?: AbortSignal }) {
    return repository.getShipmentChargeTypes(mode, config)
  }
}

export function getShipmentChargeTypes(mode?: Mode, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentChargesRepository({ httpClient })
  const get = getShipmentChargeTypesFactory({ repository })

  return get(mode, config)
}
